export interface TitleSectionProps {
  title: string
  description?: string
  customPadding?: boolean
}

export const useTitleSection = (props: TitleSectionProps) => {
  return {
    ...props,
  }
}
